import { render, staticRenderFns } from "./PreService.vue?vue&type=template&id=27d6f436&scoped=true"
import script from "./PreService.vue?vue&type=script&lang=js"
export * from "./PreService.vue?vue&type=script&lang=js"
import style0 from "./PreService.vue?vue&type=style&index=0&id=27d6f436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d6f436",
  null
  
)

export default component.exports